<div class="vertical_component_card mb-0">
    <div class="component-list-card h-100 d-flex flex-column pt-0 pb-0">
        <div class="text-center mem_plan_text mb-2 ">
            <input type="text" class="lbl_name lbl_font_style mb-2 text-center input_text_field_dialog "
                placeholder="{{'enter name'|translate}}" [ngModel]="membershipPlanModel.Name">
            <input type="text" class="lbl_price lbl_font_style mb-2 text-center input_text_field_dialog "
                placeholder="{{'enter price'|translate}}" [ngModel]="membershipPlanModel.Price">
            <div class="min-h-title">
                <input type="text" class="lbl_title lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'enter title'|translate}}" [ngModel]="membershipPlanModel.Title">
                <textarea rows="4" cols="50" class="lbl_desc lbl_font_style mb-2 text-center input_text_field_dialog "
                    placeholder="{{'enter description'|translate}}" [ngModel]="membershipPlanModel.Description">
                </textarea>
            </div>
            <label class="lbl_num">{{'Number of venues'|translate}}</label>
            <input type="text" class="lbl_num_of_ven lbl_font_style mb-2 pb-0 text-center input_text_field_dialog "
                placeholder="{{'enter number of venues'|translate}}" [ngModel]="membershipPlanModel.NumberOfVenues">
        </div>
        <div class="mt-auto">
            <button *ngIf="!enableEdit" class="btn_in_color  me-2" (click)="saveMembershipPlan(membershipPlanModel)">{{
                'SAVE' |
                translate}}</button>
            <button *ngIf="enableEdit" class="btn_in_color  me-2" (click)="editMembershipPlan(membershipPlanModel)">{{
                'EDIT' |
                translate}}</button>
            <button class="btn_without_color btn_border_color " (click)="cancel()">{{ 'CANCEL'
                | translate}}</button>
        </div>
    </div>
</div>